import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import sq from './locales/sq/translation.json';
import en from './locales/en/translation.json';
import tr from './locales/tr/translation.json';

const ALL_LOCALES = { sq, en, tr };

const langConfig = window.__UMS_THEME__?.languages || {
  lng1: { locale: 'sq', name: 'Shqip' },
  lng2: { locale: 'en', name: 'English' },
  lng3: { locale: 'tr', name: 'T\u00FCrk\u00E7e' }
};
const defaultLang = window.__UMS_THEME__?.defaultLanguage || 'lng1';

const resources = {
  lng1: { translation: ALL_LOCALES[langConfig.lng1?.locale] || sq },
  lng2: { translation: ALL_LOCALES[langConfig.lng2?.locale] || en },
};
if (langConfig.lng3) {
  resources.lng3 = { translation: ALL_LOCALES[langConfig.lng3?.locale] || tr };
}

Object.keys(resources).forEach((slot) => {
  const orig = resources[slot].translation;
  resources[slot].translation = {
    ...orig,
    ...(langConfig.lng1?.name && { languageLNG1: `(${langConfig.lng1.name})` }),
    ...(langConfig.lng2?.name && { languageLNG2: `(${langConfig.lng2.name})` }),
    ...(langConfig.lng3?.name && { languageLNG3: `(${langConfig.lng3.name})` }),
  };
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      order: ['localStorage', 'cookie', 'querystring', 'navigator', 'htmlTag', 'path', 'subdomain'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: ['i18next', 'lang'],
      caches: ['localStorage', 'cookie'],
      lowerCaseLng: true,
    },
    fallbackLng: defaultLang,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
